import {
  companyCodeColumnDefinition,
  deferredAccountColumnDefinition,
  deferredGroupingColumnDefinition,
  grossBalanceColumnDefinition,
  countryTaxTypeColumnDefinition,
  bookTypeColumnDefinition,
  currencyCodeColumnDefinition,
  historicalRateColumnDefinition,
  netBalanceColumnDefinition,
  newRateColumnDefinition,
  adjustedNetBalanceColumnDefinition,
  rateChangeEntryColumnDefinition,
  commentColumnDefinition,
} from '../columnDefinitions';
import PercentageCellEditor from '../agGrid/cellEditors/PercentageCellEditor';
import highlightEdited from '../../balanceSheetManagement/rateChangeWorkpaperPage/highlightEdited';
import PercentageOrRawRenderer from '../cellRenderers/percentageOrRawCellRenderer.component';

export default handleEnterPressed => [
  companyCodeColumnDefinition,
  deferredAccountColumnDefinition,
  deferredGroupingColumnDefinition,
  grossBalanceColumnDefinition,
  {
    ...countryTaxTypeColumnDefinition,
    field: 'taxTypeDescription',
    width: 200,
    minWidth: 200,
  },
  bookTypeColumnDefinition,
  {
    ...currencyCodeColumnDefinition,
    width: 100,
    minWidth: 90,
  },
  historicalRateColumnDefinition,
  netBalanceColumnDefinition,
  {
    ...newRateColumnDefinition,
    cellRenderer: highlightEdited(PercentageOrRawRenderer),
    editable: true,
    cellEditorPopup: true,
    suppressKeyboardEvent: params => {
      const enterPressed = params.event.key === 'Enter';
      if (enterPressed && handleEnterPressed) {
        handleEnterPressed(params);
      }
      return enterPressed;
    },
    valueParser: ({ newValue }) => !isNaN(parseFloat(newValue)) ? parseFloat(newValue) : null,
    cellEditor: PercentageCellEditor,
  },
  {
    ...adjustedNetBalanceColumnDefinition,
    cellRenderer: highlightEdited(adjustedNetBalanceColumnDefinition.cellRenderer),
  },
  {
    ...rateChangeEntryColumnDefinition,
    cellRenderer: highlightEdited(rateChangeEntryColumnDefinition.cellRenderer),
  },
  {
    ...commentColumnDefinition,
    cellEditorPopup: true,
  },
];
